import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type { DeleteAffiliatePayoutMethodRequest } from './delete-affiliate-payout-method.types'

const deleteAffiliatePayoutMethod = async ({
  id,
}: DeleteAffiliatePayoutMethodRequest): Promise<void> => {
  await apiClient.delete(`/v1/affiliation/payout-methods/${id}`)
}

interface UseDeleteAffiliatePayoutMethodOptions {
  feedback?: MutationFeedback
}

export const useDeleteAffiliatePayoutMethod = (
  options?: UseDeleteAffiliatePayoutMethodOptions,
) => {
  return useMutation({
    mutationFn: deleteAffiliatePayoutMethod,
    meta: {
      invalidatesQuery: ['affiliate-payout-methods'],
      ...options?.feedback,
    },
  })
}
